import LeaveRecord from '@/api/leave-record'
import Employee from '@/api/employee'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'
import { join } from 'lodash'

export const state = {
  ...baseState,
  employees: [],
  leaveTypes: [],
  times: [],
  edit_data: {},
  date_range: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_EMPLOYEES(state, data) {
    state.employees = data
  },
  RECEIVE_LEAVE_TYPES(state, data) {
    state.leaveTypes = data
  },
  RECEIVE_TIMES(state, data) {
    state.times = data
  },
  SET_DEPARTMENT_ID(state, data) {
    state.department_id = data
  },
  SET_BRANCH_ID(state, data) {
    state.branch_id = data
  },
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_DATE_RANGE(state, date) {
    state.date_range = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        department_id: context.state.department_id,
        branch_id: context.state.branch_id,
        search: context.state.search,
        date_between: context.state.date_range
      },
      attrubutes
    )
    return LeaveRecord.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return LeaveRecord.store(data)
  },

  update(context, { id, data }) {
    return LeaveRecord.update(id, data)
  },
  destroy(context, data) {
    return LeaveRecord.destroy(data)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await LeaveRecord.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  fetchEmployees(context, attributes = {}) {
    let params = {
      page: -1,
      include: 'position,shift',
      fields: {
        setup_staff_information:
          'staff_id,name_en,name_kh,emp_id,gender,phone_number_1,date_of_birth,position_id,shift_id,photo,department_id',
        position: 'position_id,pos_name_en',
        shift: 'shift_id,shift_name,shift_type'
      },
      filter: {
        status_active: 'Active',
        department_id: attributes.department_id
      },
      ...attributes
    }

    return Employee.get({ params }).then(response => {
      context.commit('RECEIVE_EMPLOYEES', response.data)
      return Promise.resolve(response)
    })
  },

  async getTimeFromTo(context, data) {
    if (!data.staff_id || !data.date_from || !data.date_to) {
      let response = await LeaveRecord.getTime(data)
      context.commit('RECEIVE_TIMES', response.data)
    }
    return
  },

  getTotal(context, data) {
    return LeaveRecord.getTotalDay(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.leaveTypes.length > 0) {
      let response = await LeaveRecord.leaveType()
      context.commit('RECEIVE_LEAVE_TYPES', response.data)
    }
  },

  getDepartment(context, data) {
    return LeaveRecord.department(data)
  },

  getBranch(context, data) {
    return LeaveRecord.branch(data)
  }
}
